<template>
<div class ="tips" >
      <div class="weui-msg box1">
        <!-- <div class="weui-msg__icon-area"><i class="weui-icon-success weui-icon_msg"></i></div> -->
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">提示信息(货机号：{{ machineId }})</h2>
            <p class="weui-msg__desc">{{tipInfo}}</p>
        </div>
        <div class="weui-msg__opr-area">
            <p class="weui-btn-area">
                <a href="javascript:;" v-show="btnshow" class="weui-btn weui-btn_primary" @click="hideMask">确 定</a>
                <a href="javascript:;" v-show="btnreload" class="weui-btn weui-btn_primary" @click="hideMask">重选商品</a>
                <a href="javascript:;" v-show="btnpay" class="weui-btn weui-btn_primary" @click="continueP">继续支付</a>
                <!-- <a href="javascript:;" class="weui-btn weui-btn_default">取 消</a> -->
            </p>
        </div>
        <div class="weui-msg__extra-area">

        </div>
    </div>
	<div class="tpis-mask"></div>
	</div>
</template>

<script>
export default {
	name: 'Tips',
  	data () {
	    return { 
	    }
	},
	methods: {
		hideMask(){
      this.$emit("tipShow")
		},
    continueP(){
      this.$emit("continuePay")
    }

	},
  props:['tipInfo','btnshow','btnreload','btnpay','machineId'],
      
}

</script>


<style>
@import url('../../common/css/style.css');
@import url('../../common/css/weui.css');
.tips{
  text-align:center;
}
.tips .box1{
  position: fixed;
  z-index: 9001;
  width:70%;
  top:30%;
  left:15%;
  font-size:16px;
  background-color: #F0F0F0;
}

.tips .tpis-mask{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 9000;
	background: rgba(7,17,27,0.6);
}


</style>


// WEBPACK FOOTER //
// src/components/tips/Tips.vue